import React from "react";
import _ from "lodash";
import classNames from "classnames";
import { Button, Modal } from "@toddle-edu/ds-web";
import { CloseCircleOutlined, TickCircleFilled } from "@toddle-edu/ds-icons";

import { useI18n } from "Hooks";
import { ORG_ADD_ONS_MAPPING_V2 } from "AddOnManager/routes/OrgAddOn/modules/OrgAddOnHelpers";

import classes from "./AddonsConfirmationModal.scss";
import { addonsModalBodyStyles } from "./styles";
import { groupAddonsByCurriculum } from "../../modules/AddOnManagerUtils";

export const AddonsConfirmationModal = props => {
  const {
    closeModal,
    onSave,
    testId,
    curriculumPrograms,
    toggledOrgAddons,
    toggledCurriculumAddons,
  } = props;
  const { t } = useI18n(["common"]);
  const localTestId = `${testId}-confirmationModal`;
  const entityLabelClass = classNames({
    "text-label": true,
    [classes.entityLevelAddonsContainerLabel]: true,
  });
  const addonsMap = _.keyBy(ORG_ADD_ONS_MAPPING_V2, "id");

  const groupedCurriculumLevelAddons = groupAddonsByCurriculum({
    toggledCurriculumAddons,
    curriculumList: curriculumPrograms,
  });

  const renderAddonRow = addon => {
    const addonId = _.get(addon, "addOnId", "");
    const addonStatus = _.get(addon, "status", "");
    const isEnabled = addonStatus === "enabled";

    const IconComponent = isEnabled ? TickCircleFilled : CloseCircleOutlined;

    const iconVariant = isEnabled ? "success" : "critical";
    const statusLabel = isEnabled ? t("common:enabled") : t("common:disabled");

    return (
      <div key={addonId} className={classes.individualAddonContainer}>
        <span className="">{t(_.get(addonsMap, [addonId, "label"], ""))}</span>

        <div className={classes.toggleContainer}>
          <span className={classes.iconContainer}>
            <IconComponent variant={iconVariant} size="xxx-small" />
          </span>
          <span className="text-body">{statusLabel}</span>
        </div>
      </div>
    );
  };

  return (
    <Modal
      height="max-content"
      hasOverlay={true}
      width="480px"
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onClose={closeModal}
      isOpen={true}
    >
      <Modal.Header title={t("common:save_changes")} testId={localTestId} />
      <Modal.Body isScrollable={true} style={addonsModalBodyStyles}>
        The following changes were made:
        {!_.isEmpty(toggledOrgAddons) && (
          <>
            <div className={entityLabelClass}>Account Level Addons</div>
            {toggledOrgAddons.map(addon => renderAddonRow(addon))}
          </>
        )}
        {!_.isEmpty(groupedCurriculumLevelAddons) && (
          <>
            <div className={entityLabelClass}>Curriculum Level Addons</div>
            <div className={classes.entityLevelAddonsContainer}>
              {groupedCurriculumLevelAddons.map(
                ({ curriculumId, label, addons }) => (
                  <div key={curriculumId}>
                    <div className="text-label">{label}</div>
                    {addons.map(addon => renderAddonRow(addon))}
                  </div>
                )
              )}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.buttonWrapper}>
          <Button
            variant="neutral"
            type="outlined"
            onClick={closeModal}
            testId={`${localTestId}-cancel`}
          >
            {t("common:cancel")}
          </Button>
          <Button onClick={onSave} testId={`${localTestId}-save`}>
            {t("common:save")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddonsConfirmationModal;
